import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles(({ palette, colors, breakpoints }: Theme) => createStyles({
  container: {
    height: '100%',
    background: '#FFF',
    padding: '45px 8px 55px',
    textAlign: 'center',
    fontSize: 16,
    fontFamily: '"Roboto", "Regular"',

    [breakpoints.down('sm')]: {
      minHeight: 350,
      padding: '15px 8px 25px',
    },

    [breakpoints.down(700)]: {
      minHeight: 365,
    },

    [breakpoints.down(450)]: {
      minHeight: 390,
    },

  },
  containerCentered: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  title: {
    marginBottom: 15,
    fontSize: 22,
    fontFamily: '"Montserrat", "Regular"',
    fontWeight: 700,
  },
  subTitle: {
    marginBottom: 15,
    fontSize: 14,
    fontFamily: '"Montserrat", "Regular"',
    fontWeight: 400,
  },
  description: {
    minHeight: 100,
    width: '88%',
    margin: '0 auto',
    [breakpoints.down(990)]: {
      minHeight: 120,
    },

    [breakpoints.down('sm')]: {
      width: '100%',
      minHeight: 30,
    },

    [breakpoints.down(700)]: {
      minHeight: 45,
    },

    [breakpoints.down(450)]: {
      minHeight: 68,
    },

  },
  planTitle: {
    marginBottom: 5,
    color: '#26325F',
    fontSize: 36,
    fontWeight: 700,
    fontFamily: '"Montserrat", "SemiBold"',

    [breakpoints.down(1300)]: {
      fontSize: 32,
    },
    [breakpoints.down(990)]: {
      fontSize: 28,
    },
  },
  planDuration: {
    fontSize: 16,
  },
  planDescription: {
    marginBottom: 16,
    [breakpoints.down(1300)]: {
      width: '90%',
      margin: '0 auto 0',
      minHeight: 60,
    },

    [breakpoints.down('sm')]: {
      minHeight: 30,
      width: '100%',
    },

  },
  buttonWrapper: {
    marginBottom: 30,

    [breakpoints.down('sm')]: {
      marginBottom: 10,
    },
  },
}), { name: 'PricingPageTableHeader' });

export default useStyles;
